import { render, staticRenderFns } from "./DbDygraphsBar.vue?vue&type=template&id=585be7f0&"
import script from "./DbDygraphsBar.vue?vue&type=script&lang=js&"
export * from "./DbDygraphsBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports